import { createSelector } from '@reduxjs/toolkit'

import { getCurrentQuarterlyTaxReturnsAnnualSummaryStartYear } from '../domain/quarterly-tax-returns-annual-summary'
import { getQuarterlyTaxReturnsAnnualSummaries } from '../store/profile'

const pluckTaxYear = (_, { taxYear }) => taxYear
const pluckQuarterlyTaxReturnsAnnualSummaryId = (_, { quarterlyTaxReturnsAnnualSummaryId }) =>
    quarterlyTaxReturnsAnnualSummaryId
const getQuarterlyTaxReturnsAnnualSummarySlice = (state) => state.quarterlyTaxReturnsAnnualSummary

export const getQuarterlyTaxReturnsAnnualSummaryById = createSelector(
    [getQuarterlyTaxReturnsAnnualSummaries, pluckQuarterlyTaxReturnsAnnualSummaryId],
    (quarterlyTaxReturnsAnnualSummaries, quarterlyTaxReturnsAnnualSummaryId) =>
        quarterlyTaxReturnsAnnualSummaries.find(
            (quarterlyTaxReturnsAnnualSummary) =>
                Number(quarterlyTaxReturnsAnnualSummary.id) === Number(quarterlyTaxReturnsAnnualSummaryId)
        )
)

export const getQuarterlyTaxReturnsAnnualSummaryByTaxYear = createSelector(
    [getQuarterlyTaxReturnsAnnualSummaries, pluckTaxYear],
    (quarterlyTaxReturnsAnnualSummaries, taxYear) =>
        quarterlyTaxReturnsAnnualSummaries.find(
            (quarterlyTaxReturnsAnnualSummary) => Number(quarterlyTaxReturnsAnnualSummary.taxYear) === Number(taxYear)
        )
)

export const getCurrentYearQuarterlyTaxReturnsAnnualSummary = createSelector(
    [getQuarterlyTaxReturnsAnnualSummaries],
    (quarterlyTaxReturnsAnnualSummaries) =>
        /**
         * Hi, future mantainer!
         * Would like to point that once per year, from 31st Dec to 1st Jan, this might be memoized with the previous years' currentYear value.
         * Current maintainer's pov is we can live with it.
         */
        quarterlyTaxReturnsAnnualSummaries.find(
            (quarterlyTaxReturnsAnnualSummary) =>
                Number(quarterlyTaxReturnsAnnualSummary.taxYear) ===
                Number(getCurrentQuarterlyTaxReturnsAnnualSummaryStartYear())
        )
)

export default createSelector(
    [getQuarterlyTaxReturnsAnnualSummarySlice],
    (quarterlyTaxReturnsAnnualSummary) => quarterlyTaxReturnsAnnualSummary
)
